module.exports = __webpack_public_path__ + "static/Chicory7-baa4eb0719cb2f663697b6c9a6d16973.webp";